import { render, staticRenderFns } from "./RecordedDeleteDialog.vue?vue&type=template&id=58362fc2&"
import script from "./RecordedDeleteDialog.vue?vue&type=script&lang=ts&"
export * from "./RecordedDeleteDialog.vue?vue&type=script&lang=ts&"
import style0 from "./RecordedDeleteDialog.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports